// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"778":"595e40d4","7271":"1047ebb3"}[chunkId] + ".chunk.css";
};